import React from "react";
import {useQuery} from "@apollo/client";
import {FormControl, MenuItem, Select} from "@mui/material";
import Grid from '@mui/material/Grid';

import {isShiftPlanAfterCurrentTime} from "../../helpers/ShiftPlanHelper";
import {QUERY_ALL_PERFORMERS_AND_FILTER_BY_SERVICE_TYPE} from "../../queries/GraphQLQueries";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250
        }
    }
};

export default function PerformerSelect({shiftPlan, handlePerformerEnrollment}) {

    const performerEnabled = isShiftPlanAfterCurrentTime(shiftPlan.startTime || shiftPlan.start);
    const serviceTypeKeycodes = shiftPlan.bookableServiceTypePlans?.map(plan => plan.serviceType.keycode) || shiftPlan.bookableServices || [];
    const {data: performersData} = useQuery(QUERY_ALL_PERFORMERS_AND_FILTER_BY_SERVICE_TYPE, {
        variables: {serviceTypeKeycodes}, fetchPolicy: 'network-only'
    });

    const sortedPerformersData = performersData && performersData.accreditedUsers.sort((a, b) => a.displayName.localeCompare(b.displayName));

    return <Grid container sx={{width: '100%'}}>
        <FormControl sx={{m: 0.5, flexGrow: 1}}>
            <Select multiple displayEmpty
                    size="small"
                    sx={{height: '2rem', '& .MuiSelect-select': {paddingX: '1.031rem', paddingY: '0rem'}}}
                    disabled={!performerEnabled}
                    value={shiftPlan.enrollments?.map(enrollment => enrollment.user.id) || []}
                    onChange={event => handlePerformerEnrollment(event, shiftPlan.id)}
                    renderValue={()=> 'Add Performer'}
                    MenuProps={MenuProps}>
                <MenuItem value="" disabled>Available Performers</MenuItem>
                {sortedPerformersData
                  && sortedPerformersData.map(performer =>
                    <MenuItem key={performer.id} value={performer.id}>{`${performer.displayName}`}</MenuItem>)
                }
            </Select>
        </FormControl>
    </Grid>;
}